import { render, staticRenderFns } from "./installment.vue?vue&type=template&id=2abd3a38&"
import script from "./installment.vue?vue&type=script&lang=js&"
export * from "./installment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports